import React from 'react'
import { useTranslation } from 'react-i18next'
import { InputLabel } from '@node-space/storybook-components/dist/FormElements'
import Input from '@node-space/storybook-components/dist/Input'
import Select from '@node-space/storybook-components/dist/Select'
import { Box } from '@node-space/ui-components'
import { AddressFields } from './types'

export interface AddressFormFieldsProps {
  label?: string
  addressFields: AddressFields
  isLoadingCountries: boolean
}

export const AddressFormFields = ({
  label,
  addressFields,
  isLoadingCountries,
}: AddressFormFieldsProps) => {
  const { t } = useTranslation()

  return (
    <Box>
      <InputLabel forId={addressFields?.address1?.name}>
        {label ?? t('formFields.residentialAddress')}
      </InputLabel>
      <Box flexCol gapY={8}>
        <Input {...addressFields?.address1} />
        <Input {...addressFields?.address2} />
        <Box flex gap={8}>
          <Box flexSize="fill" width="full">
            <Input {...addressFields?.city} />
          </Box>
          <Box flexSize="fill" width="full">
            <Input {...addressFields?.postalCode} />
          </Box>
        </Box>
        <Select {...addressFields?.countryCode} loading={isLoadingCountries} isSearchable />
      </Box>
    </Box>
  )
}
